// External links shown in the client. An empty value hides the link everywhere.

/** Invite to the Stars & Ships Discord server (community and alpha support). */
export const DISCORD_INVITE_URL = 'https://discord.gg/m2KBuStgK';
